<template>
  <OnClickOutside @trigger="$emit('close-sidebar')">
    <div class="sidebar">
      <ul class="sidebar__content">
        <li class="sidebar__content-item sidebar__content-item--languages">
          <p class="sidebar__languages-label">{{ t('Translation Language') }}</p>
          <div class="sidebar__languages-flags">
            <img
              v-for="code in translationLanguages"
              :key="code"
              :src="imageURL(flags[code])"
              :alt="languages[code]"
              class="sidebar__languages-flag"
              :class="{ 'sidebar__languages-flag--active': code === translationLanguage }"
              @click="selectTranslationLanguage(code)"
              @keydown="selectTranslationLanguage(code)"
            />
          </div>
        </li>

        <li class="sidebar__content-item">
          <router-link class="nav-item" to="/lists" @click="$emit('close-sidebar')">
            {{ t('Lists') }}
          </router-link>
        </li>

        <li class="sidebar__content-item">
          <router-link class="nav-item" to="/games" @click="$emit('close-sidebar')">
            {{ t('Games') }}
          </router-link>
        </li>

        <li class="sidebar__content-item">
          <router-link class="nav-item" to="/settings" @click="$emit('close-sidebar')">
            {{ t('Settings') }}
          </router-link>
        </li>
        <li class="sidebar__content-item">
          <router-link class="nav-item" to="/support" @click="$emit('close-sidebar')">
            {{ t('Support') }}
          </router-link>
        </li>
      </ul>
    </div>
  </OnClickOutside>
</template>
<script lang="ts">
import { mixins, Options } from 'vue-class-component';
import LanguageMixin from '@/includes/mixin/language.mixin';
import ImageMixin from '@/includes/mixin/images.mixin';
import { OnClickOutside } from '@vueuse/components';
import languages, { flags, translationLanguages } from '@/includes/db/data/languages';
import store from '@/includes/store';

@Options({
  emits: ['close-sidebar'],
  components: { OnClickOutside },
  data: () => ({}),
})
export default class Sidebar extends mixins(LanguageMixin, ImageMixin) {
  languages = languages;
  flags = flags;
  translationLanguages = translationLanguages;

  // eslint-disable-next-line class-methods-use-this
  get translationLanguage() {
    return store.state.translationLanguage;
  }

  selectTranslationLanguage(code: string) {
    store.commit('setTranslationLanguage', code);
    this.$emit('close-sidebar');
  }
}
</script>
<style scoped lang="scss">
@import "../assets/styles/variables.scss";

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  background: $light;
  color: $dark;
  height: 100vh;
  width: 80vw;
  -webkit-animation: slide 0.5s forwards;
  animation: slide 0.5s forwards;
  z-index: 1;

  &__content{
    padding: 0;
    margin-top: 90px;
    list-style-type: none;
    text-align: left;
    border-top: 1px solid rgba($secondary-2, .2);

    a{
      text-decoration: none;
      color: $secondary;
      font-size: 1.1rem;
      font-weight: 500;
    }

    &-item{
      border-bottom: 1px solid rgba($secondary-2, .2);

      > *{
        display: block;
        padding: 10px 25px;
      }

      &--languages {
        padding: 10px 25px;
      }
    }

  }

  &__languages {
    &-label {
      margin: 0;
      font-size: 0.85rem;
      padding-left: 0;
      font-weight: 500;
      color: $secondary-2;
    }

    &-flags {
      display: flex;
      padding-top: 0;
      padding-left: 0;
      gap: 12px;
    }

    &-flag {
      width: 36px;
      height: 24px;
      object-fit: cover;
      border: 2px solid transparent;
      border-radius: 3px;
      cursor: pointer;

      &--active {
        border-color: $primary;
      }
    }
  }
}

@keyframes slide {
  0% {
    width: 0;
  }
  100% {
    width: 80vw;
  }
}

@-webkit-keyframes slide {
  0% {
    width: 0;
  }
  100% {
    width: 80vw;
  }
}
</style>
